module.exports = __webpack_public_path__ + "img/plus.8ff6ae43.svg";